/*!
  _   _  ___  ____  ___ ________  _   _   _   _ ___   
 | | | |/ _ \|  _ \|_ _|__  / _ \| \ | | | | | |_ _| 
 | |_| | | | | |_) || |  / / | | |  \| | | | | || | 
 |  _  | |_| |  _ < | | / /| |_| | |\  | | |_| || |
 |_| |_|\___/|_| \_\___/____\___/|_| \_|  \___/|___|
                                                                                                                                                                                                                                                                                                                                       
=========================================================
* Horizon UI - v1.1.0
=========================================================

* Product Page: https://www.horizon-ui.com/
* Copyright 2023 Horizon UI (https://www.horizon-ui.com/)

* Designed and Coded by Simmmple

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// Chakra imports
import {
    Box,
    SimpleGrid,
    Button,
    Link
} from "@chakra-ui/react";
// Assets
import React from "react";
import { Link as RouterLink } from 'react-router-dom';

import ComplexTable from "views/admin/supportList/components/ComplexTable";

export default function SupportList() {
    return (
        <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
           
            <SimpleGrid gap='20px' mb='20px'>
            <Link as={RouterLink} to="/admin/add-support-member">
                <Button colorScheme="green" size="md" right="20px" float={"right"}>
                    Add Support Member
                </Button>
            </Link>
                <ComplexTable />
            </SimpleGrid>
        </Box>
    );
}
